export default "__VITE_ASSET__CpKr6uxD__"